<template>
	<form v-if="formReady" class="wide" @submit.prevent="submit()">
		<fieldset v-for="(section, sectionIndex) in structure" :key="sectionIndex">
			<div>
				<div>
					<legend v-if="section.title"><span v-html="section.title"/></legend>
					<div v-if="section.script" class="editorial" v-html="section.script"/>
				</div>
				<div>
					<template v-for="question in section.questions">
						<label v-if="'checkbox' === question.type" class="checkbox">
							<span v-html="question.question"/>
							<input
								v-model="form.data.data[service.key].data[question.apiMapping.inbound]" type="checkbox">
						</label>
						<label v-if="'money' === question.type">
							<span v-html="question.question"/>
							<money v-model="form.data.data[service.key].data[question.apiMapping.inbound]"/>
						</label>
						<label v-if="'number' === question.type">
							<span v-html="question.question"/>
							<input
								v-model="form.data.data[service.key].data[question.apiMapping.inbound]"
								type="number">
						</label>
						<label v-if="'select' === question.type">
							<span v-html="question.question"/>
							<select v-model="form.data.data[service.key].data[question.apiMapping.inbound]">
								<option
									v-for="(option, optionIndex) in question.options" :key="optionIndex"
									:value="option.label"
									v-html="option.label"></option>
							</select>
						</label>
						<label v-if="'text' === question.type">
							<span v-html="question.question"/>
							<input v-model="form.data.data[service.key].data[question.apiMapping.inbound]" type="text">
						</label>
						<label v-if="'textarea' === question.type">
							<span v-html="question.question"/>
							<textarea
								v-model="form.data.data[service.key].data[question.apiMapping.inbound]"></textarea>
						</label>
					</template>
				</div>
			</div>
		</fieldset>
		<fieldset v-if="!fieldsOnly">
			<div>
				<div></div>
				<div>
					<!--					<label class="checkbox"><span>Is This Fact Find Complete? </span>-->
					<!--						<input type="checkbox" v-model="form.data.complete">-->
					<!--					</label>-->
					<ul class="actions">
						<li>
							<process-button
								:processing="form.processing" :text="form.data.complete ? 'Complete Fact Find' : 'Save Fact Find'"
								class="button button--primary"/>
						</li>
					</ul>
				</div>
			</div>
		</fieldset>
	</form>
</template>
<script>
import MoneyField from "../../../../movingBuddies/views/protocolPack/forms/MoneyField.vue";

export default {
	components: {MoneyField},
	data() {
		return {
			formReady: false,
		};
	},

	props: {
		form: {
			required: true,
			type: Object,
		},
		service: {
			required: true,
			type: Object,
		},
		structure: {
			required: true,
			type: Array,
		},
		data: {
			required: false,
			type: Object,
		},
		fieldsOnly: {
			type: Boolean,
			default() {
				return false;
			},
		},
	},

	methods: {
		async submit() {
			this.$emit("submit", this.form.data);
		},
	},

	created() {
		this.form.set("data." + this.service.key + ".data", this.data || {});
		this.formReady = true;
	},
};
</script>
